import { Controller } from "@hotwired/stimulus"

// Drives the plain invite screen. The Member/Staff choice decides whether the
// category dropdown offers member categories or staff departments, so the two
// stay in step without the person filling the form having to know the
// difference between them.
export default class extends Controller {
  static targets = ["roleInput", "orgSelect", "categorySelect", "categoryHint"]
  static values = {
    departments: { type: Array, default: [] }
  }

  connect() {
    this.filterCategories()
  }

  roleChanged() {
    this.filterCategories()
  }

  orgChanged() {
    this.filterCategories()
  }

  filterCategories() {
    if (!this.hasCategorySelectTarget) return

    const role = this.selectedRole()
    const orgId = this.hasOrgSelectTarget && this.orgSelectTarget.value
      ? parseInt(this.orgSelectTarget.value, 10)
      : null

    let departments = this.departmentsValue
    if (orgId) departments = departments.filter((d) => d.org_id === orgId)
    departments = departments.filter((d) => (d.dept_type || "member") === role)

    const select = this.categorySelectTarget
    const previous = select.value

    while (select.options.length > 1) select.remove(1)

    departments.forEach((d) => {
      const option = document.createElement("option")
      option.value = d.name
      option.textContent = d.name
      if (d.name === previous) option.selected = true
      select.appendChild(option)
    })

    this.updateHint(role, departments.length)
  }

  selectedRole() {
    const checked = this.roleInputTargets.find((input) => input.checked)
    return checked ? checked.value : "member"
  }

  updateHint(role, count) {
    if (!this.hasCategoryHintTarget) return

    if (count === 0) {
      this.categoryHintTarget.textContent = role === "employee"
        ? "No staff departments set up for this club yet. Optional — can be set later."
        : "No member categories set up for this club yet. Optional — can be set later."
      return
    }

    this.categoryHintTarget.textContent = role === "employee"
      ? "Their department, e.g. Bartender or Valet. Optional."
      : "Their member category. Optional."
  }
}
